import axios from "axios";
import { axiosConfig } from "../../config";
import {
    DELEGATEBYADMIN_ADDED,
    CURRENT_DELEGATE,
    DELEGATEBYADMIN_FETCHED,
    DELEGATEBYADMIN_DELETED
} from "../types";
import { setServerErrors } from "./common";

export const getDelegateByAdmin = () => (dispatch: any) => {
    axios.get(`/api/delegation/getalldelegate`, axiosConfig).then((res) => {
        dispatch({
            type: DELEGATEBYADMIN_FETCHED,
            delegateByAdminData: res.data
        });
    }).catch((err) => {
        console.error(err);
    });
};

// export const getDelegated = (delegatedBy : string) => (dispatch : any) => {
//     axios.get(`api/delegation/${delegatedBy}`, axiosConfig).then((res) => {
//         dispatch({type: DELEGATE_FETCHED, delegate: res.data.delegate});
//     }).catch((err) => {
//         console.error(err);
//     });
// };

export const addDelegateAdmin = (values: any) => (dispatch: any, getState: any) => {
    // const delegatedBy = sessionStorage.getItem("loggedinUser");
    const {
        delegatedBy,
        delegatedTo,
        startDate,
        endDate
    } = values
    // const delegateData = {
    //     delegatedBy:values.delegateBy,
    //     delegatedTo:values.delegatedTo,
    //     startDate:values.startDate,
    //     endDate:values.endDate,
    // };

    return new Promise((resolve, reject) => {
        axios.post(`/api/delegation/addDelegate`, {
            delegatedBy,
            delegatedTo,
            startDate,
            endDate
        }, axiosConfig).then((_res) => {
            dispatch({ type: DELEGATEBYADMIN_ADDED });
            dispatch(getDelegateByAdmin());
            resolve(true);
        }).catch((err) => {
            dispatch(setServerErrors(err.response.data));
            reject(err.response.data);
        });
    });
};

export const editDelegateAdmin = (delegationId: string, delegatedTo: string) => (dispatch: any) => {
    axios.put(`/api/delegation/${delegationId}`, {
        delegatedTo
    }, axiosConfig).then((_res) => {
        // dispatch({type: DELEGATE_EDITED});
        // dispatch(getDelegate());
    }).catch((err) => {
        console.error(err);
    });
};
export const removeDelegateAdmin = (delegationId: string) => (dispatch: any) => {
    axios.delete(`/api/delegation/${delegationId}`, axiosConfig).then((_res) => {
        dispatch({ type: DELEGATEBYADMIN_DELETED });
        dispatch(getDelegateByAdmin());
    }).catch((err) => {
        console.error(err);
    });
};

export const setCurrentDelegateforAdmin = (delegate: any) => {
    return { type: CURRENT_DELEGATE, delegate };
};



